// extracted by mini-css-extract-plugin
export default {"header":"header_header__9VcW0","heading":"header_heading__JGdML"};